import React from 'react'

import './statistics.module.scss'

export function Statistics() {
  return (
    <div>
      <h1>Welcome to statistics!</h1>
    </div>
  )
}

export default Statistics
